import script from "./contacts-list.vue?vue&type=script&setup=true&lang=js"
export * from "./contacts-list.vue?vue&type=script&setup=true&lang=js"

import "./contacts-list.vue?vue&type=style&index=0&id=ace4940e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ace4940e"]])

export default __exports__